export const CREATE_DAYS_IN_MONTH = 'CREATE_DAYS_IN_MONTH';
export const SELECTED_DATE = 'SELECTED_DATE';
export const SELECTED_MONTH = 'SELECTED_MONTH';
export const REQUEST_SPECIALIST_BY_HOSPITAL = 'REQUEST_SPECIALIST_BY_HOSPITAL';
export const REQUEST_SPECIALIST_BY_HOSPITAL_SUCCESS =
  'REQUEST_SPECIALIST_BY_HOSPITAL_SUCCESS';
export const REQUEST_SPECIALIST_BY_HOSPITAL_FAIL =
  'REQUEST_SPECIALIST_BY_HOSPITAL_FAIL';
export const SELECTED_SPECIALIST = 'SELECTED_SPECIALIST';
export const HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST =
  'HIDE_MODAL_CONFIRM_SELECTED_SPECIALIST';
export const HIDE_MODAL_FILTER_SPECIALIST = 'HIDE_MODAL_FILTER_SPECIALIST';
export const SET_SEARCH_PATTERN = 'SET_SEARCH_PATTERN';
export const RESET_ALL_PROPS_DATE_AND_SPECIALIST =
  'RESET_ALL_PROPS_DATE_AND_SPECIALIST';

export const RESET_SELECT_DATE_AND_SPECIALIST =
  'RESET_SELECT_DATE_AND_SPECIALIST';

export const RESET_SELECT_DATE = 'RESET_SELECT_DATE';

export const ADD_SPECIALIST_MORE = 'ADD_SPECIALIST_MORE';

export const HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY =
  'HIDE_ALERT_INVALID_YEAR_WITH_SPECIALTITY';
export const SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY =
  'SHOW_ALERT_INVALID_YEAR_WITH_SPECIALTITY';

export const SHOW_ALERT_MAX_SPECIALIST = 'SHOW_ALERT_MAX_SPECIALIST';
export const HIDE_ALERT_MAX_SPECIALIST = 'HIDE_ALERT_MAX_SPECIALIST';

export const SHOW_ALERT_HOLIDAY_MODAL = 'SHOW_ALERT_HOLIDAY_MODAL';
export const HIDE_ALERT_HOLIDAY_MODAL = 'HIDE_ALERT_HOLIDAY_MODAL';

export const FILL_BY_FOLLOWUP = 'FILL_BY_FOLLOWUP';
export const SHOW_ALERT_GUIDE_LINE_MODAL = 'SHOW_ALERT_GUIDE_LINE_MODAL';
export const HIDE_ALERT_GUIDE_LINE_MODAL = 'HIDE_ALERT_GUIDE_LINE_MODAL';
export const SELECTED_CALENDAR_SHOW_ONE_ROW = 'SELECTED_CALENDAR_SHOW_ONE_ROW';
export const RESET_SHOW_ONE_ROW = 'RESET_SHOW_ONE_ROW';
export const SHOW_LIST_SPECIALIST_INLINE = 'SHOW_LIST_SPECIALIST_INLINE';
export const HIDE_LIST_SPECIALIST_INLINE = 'HIDE_LIST_SPECIALIST_INLINE';
export const CLOSE_TO_CHOOSE_CALENDAR_AGAIN = 'CLOSE_TO_CHOOSE_CALENDAR_AGAIN';
export const RESET_ADD_MORE_SPECIALIST = 'RESET_ADD_MORE_SPECIALIST';
